module.exports = __webpack_public_path__ + "img/445.66a96b2a.jpg";